import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import React, {ReactElement} from "react";

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}

export function reactChildrenByTypeOptional<T extends React.ElementType> (children: React.PropsWithChildren["children"], type: T): ReactElement<T> | null {
    // Find specific children by their type
    const childrenArray = React.Children.toArray(children) as ReactElement[];

    const child = childrenArray.find(
        child => child.type === type
    );

    return (child ?? null) as ReactElement<T> | null;
}

export function reactChildrenByType<T extends React.ElementType> (children: React.PropsWithChildren["children"], type: T): ReactElement<T> {
    const res = reactChildrenByTypeOptional<T>(children, type);
    if (!res) {
        console.log(children);
        throw new Error(`Component requires a child of type ${(type as any).name ?? "unknown"}`);
    }
    return res;
}